import type { ReactNode } from 'react';

interface FormFieldProps {
  label: string;
  required?: boolean;
  /** Shown under the control; hidden once an error replaces it. */
  hint?: ReactNode;
  error?: string;
  children: ReactNode;
}

/** A visible label wrapping its control, with an optional hint or error line. */
export function FormField({ label, required, hint, error, children }: FormFieldProps) {
  return (
    <label className="flex flex-col gap-1.5">
      <span className="text-[13px] font-medium">
        {label}
        {required && <span className="text-chip-critical-fg"> *</span>}
      </span>
      {children}
      {error ? (
        <span className="text-[12px] text-chip-critical-fg">{error}</span>
      ) : hint ? (
        <span className="text-[12px] text-fg-muted">{hint}</span>
      ) : null}
    </label>
  );
}
